import { render, staticRenderFns } from "./LocationOverview.vue?vue&type=template&id=041fb33f&scoped=true&"
import script from "./LocationOverview.vue?vue&type=script&lang=ts&"
export * from "./LocationOverview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041fb33f",
  null
  
)

export default component.exports